import React from 'react';

interface CodesTabProps {
    selectedTeam: any;
    isDark: boolean;
    copiedCode: string;
    copyToClipboard: (code: string, type: string) => void;
}

const CodesTab: React.FC<CodesTabProps> = ({ selectedTeam, isDark, copiedCode, copyToClipboard }) => (
    <div className="space-y-6">
        <div className="text-center mb-8">
            <h3 className="text-3xl font-bold cgm-text-primary mb-2">Team Join Codes</h3>
            <p className="text-lg cgm-text-secondary">Share these codes to invite coaches and athletes</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Coach Code */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-2xl p-8 border border-blue-200/50 dark:border-blue-700/50 text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center text-white text-3xl mx-auto mb-6">
                    👨‍💼
                </div>
                <h4 className="text-2xl font-bold cgm-text-primary mb-3">Coach Code</h4>
                <p className="cgm-text-secondary mb-6">For inviting coaching staff</p>
                <div className="space-y-4">
                    <code className="block px-6 py-4 rounded-xl bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300 font-code text-2xl font-bold tracking-wider">
                        {selectedTeam.coach_code}
                    </code>
                    <button
                        onClick={() => copyToClipboard(selectedTeam.coach_code, 'coach')}
                        className={`w-full px-6 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 ${copiedCode === `coach-${selectedTeam.coach_code}`
                                ? 'bg-green-500 text-white'
                                : 'bg-blue-500 text-white hover:bg-blue-600'
                            }`}
                    >
                        {copiedCode === `coach-${selectedTeam.coach_code}` ? '✓ Copied to Clipboard!' : 'Copy Code'}
                    </button>
                </div>
            </div>
            {/* Athlete Code */}
            <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900/20 dark:to-emerald-800/20 rounded-2xl p-8 border border-emerald-200/50 dark:border-emerald-700/50 text-center">
                <div className="w-20 h-20 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-2xl flex items-center justify-center text-white text-3xl mx-auto mb-6">
                    🏃‍♂️
                </div>
                <h4 className="text-2xl font-bold cgm-text-primary mb-3">Athlete Code</h4>
                <p className="cgm-text-secondary mb-6">For inviting team athletes</p>
                <div className="space-y-4">
                    <code className="block px-6 py-4 rounded-xl bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300 font-code text-2xl font-bold tracking-wider">
                        {selectedTeam.athlete_code}
                    </code>
                    <button
                        onClick={() => copyToClipboard(selectedTeam.athlete_code, 'athlete')}
                        className={`w-full px-6 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 ${copiedCode === `athlete-${selectedTeam.athlete_code}`
                                ? 'bg-green-500 text-white'
                                : 'bg-emerald-500 text-white hover:bg-emerald-600'
                            }`}
                    >
                        {copiedCode === `athlete-${selectedTeam.athlete_code}` ? '✓ Copied to Clipboard!' : 'Copy Code'}
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export default CodesTab; 